<template>
    <section class="section-padding" id="moj-auto">
        <h2 class="text-center">Moj auto</h2>

        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-4"
        >
            <p class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                Sekcija „Moj auto” omogućava ti da u aplikaciji sačuvaš osnovne
                podatke o svom vozilu i na jednom mestu pratiš sve važne
                informacije.
                <br /><br />
                <strong>
                    Možeš da uneseš model i fotografiju automobila koji voziš,
                    kao i datume isteka vozačke i saobraćajne dozvole.
                </strong>
                Na taj način su ti podaci uvek dostupni u aplikaciji, bez
                potrebe da ih posebno pamtiš ili proveravaš, a aplikacija će te
                svakako na vreme podsetiti kada se približava istek vozačke ili
                saobraćajne dozvole kako bi izbegao nenamerne propuste.
                <br /><br />
                Ova opcija ti pomaže i da lakše pratiš svoju potrošnju goriva.
                Sam biraš period za koji želiš da vidiš potrošnju, a aplikacija
                ti prikazuje pregled na osnovu tvojih kupovina. Tako možeš
                jednostavnije da pratiš koliko trošiš, upoređuješ periode i imaš
                bolji uvid u svoje navike u vožnji.
                <br /><br />
                <strong>
                    „Moj auto” je praktična sekcija koja ti pomaže da podatke o
                    vozilu, potrošnju i važne rokove držiš pod kontrolom.
                </strong>
                Jednostavno, pregledno i uvek pri ruci.
            </p>
            <img
                width="588"
                height="699"
                loading="lazy"
                class="img-fluid max-w-sm"
                src="/img/application/original/my-car.webp"
                sizes="(min-width: 768px) 768px, 100vw"
                srcset="
                    /img/application/sm/my-car.webp   384w,
                    /img/application/lg/my-car.webp   512w,
                    /img/application/3xl/my-car.webp  768w,
                    /img/application/5xl/my-car.webp 1024w,
                    /img/application/7xl/my-car.webp 1280w,
                    /img/application/8xl/my-car.webp 1536w,
                    /img/application/9xl/my-car.webp 1920w
                "
                alt="Moj auto"
            />
        </div>
    </section>
</template>

<style scoped>
img {
    width: 36.75rem;
}

@media (max-width: 768px) {
    img {
        width: 100%;
    }
}
</style>
